import axios from 'axios';
import authConfig from "src/configs/auth"
import { toast } from "react-hot-toast"
import { PublicRoutes } from 'src/utils/constants';
import i18n from 'src/configs/i18n'

export const axiosInstance = axios.create({
    headers: {
        "Content-Type": "application/json",
        "authorization": `Bearer ${localStorage.getItem(authConfig.storageTokenKeyName)}`,
    },
});

// You can set default headers like Content-Type here
axiosInstance.defaults.headers.common['Content-Type'] = 'application/json';

// Add a request interceptor to set the authorization header
axiosInstance.interceptors.request.use(
    (config) => {
        // Get the token from localStorage and set the authorization header
        const token = window.localStorage.getItem(authConfig.storageTokenKeyName);
        if (token) {
            config.headers['authorization'] = `Bearer ${token}`;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

// Add an interceptor to handle 401 responses - Invalid/Expired token
axiosInstance.interceptors.response.use(
    response => response,
    error => {
        if (error.response) {
            const { status, data } = error.response;
            const currentPath = String(window.location.pathname || '').replace(/\/+$/, '');
            const isPublicByAllowList = Array.isArray(PublicRoutes) && PublicRoutes.includes(currentPath);

            const logoutUser = () => {
                window.localStorage.removeItem(authConfig.storageUserDataKeyName);
                window.localStorage.removeItem(authConfig.storageTokenKeyName);

                if (!isPublicByAllowList) {
                    toast.error(i18n.t('auth.sessionExpired'));
                    window.location.href = '/login';
                }
            };

            if (status === 401) {
                logoutUser();
            } else if (status === 403) {
                const message = data?.message || i18n.t('auth.accessDenied');
                if (!isPublicByAllowList) {
                    toast.error(message);
                }
            }
        }

        return Promise.reject(error);
    }
);

// access token ->  8hr
// refresh token -> 90 days
